/**
 * Canonical private Chat browser-state helper (Phase 2 Slice 7C).
 * Clears only private Chat keys — not unrelated product preferences.
 */

const PRIVATE_CHAT_KEY_PREFIXES = [
  'agent_david_active_session_',
  'chat_context_',
  'chat_skill_',
  'chat_skills_',
];

/**
 * Remove private Chat persistence keys from localStorage.
 * Does not call localStorage.clear() and does not remove unrelated prefs
 * (e.g. Recents drawer open/closed display preference).
 */
export function clearPrivateChatBrowserState() {
  if (typeof localStorage === 'undefined') return;
  const toRemove = [];
  for (let i = 0; i < localStorage.length; i += 1) {
    const key = localStorage.key(i);
    if (!key) continue;
    if (PRIVATE_CHAT_KEY_PREFIXES.some((prefix) => key.startsWith(prefix))) {
      toRemove.push(key);
    }
  }
  for (const key of toRemove) {
    localStorage.removeItem(key);
  }
}

export function privateChatStoragePrefixes() {
  return [...PRIVATE_CHAT_KEY_PREFIXES];
}

export function activeSessionStorageKey(profileId) {
  return profileId ? `agent_david_active_session_${profileId}` : null;
}

/** Write a known session. A null sessionId is hydration and must not delete the key. */
export function persistKnownActiveSession(storage, profileId, sessionId) {
  const key = activeSessionStorageKey(profileId);
  if (!storage || !key || !sessionId) return;
  storage.setItem(key, sessionId);
}

export function readStoredActiveSession(storage, profileId) {
  const key = activeSessionStorageKey(profileId);
  if (!storage || !key) return null;
  return storage.getItem(key);
}

export function clearStoredActiveSession(storage, profileId) {
  const key = activeSessionStorageKey(profileId);
  if (!storage || !key) return;
  storage.removeItem(key);
}
